import Vue from 'vue';
import gsap from 'gsap';
// eslint-disable-next-line import/no-named-as-default
import SplitText from '../gsap-bonus/SplitText';

gsap.registerPlugin(SplitText);

Vue.component('home-slider-component', {
    props: {
        slides: {
            type: Array,
            default: () => [],
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 1,
            maxIndex: 1,
            nextButton: null,
            prevButton: null,
            movement: null,
            isTiming: false,
            timerTl: null,
            inProgress: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.maxIndex = this.slides.length;
        this.nextButton = this.$el.querySelector('.slider__controls-next');
        this.prevButton = this.$el.querySelector('.slider__controls-previous');
        this.triggerTimer();
        const mySplitText = new SplitText(this.$el.querySelector('.home-slider__slide-text'), { type: 'lines', linesClass: 'line-reveal-line' });
        const dupSplitText = new SplitText(this.$el.querySelector('.home-slider__slide-text'), { type: 'lines', linesClass: 'line-reveal-line-holder' });

        gsap.set(this.$el.querySelector('.home-slider__slide-text'), { opacity: 1 });
        gsap.to(this.$el.querySelectorAll('.home-slider__slide-text .line-reveal-line'), {
            opacity: 1,
            y: 0,
            ease: 'Power2.out',
            stagger: 0.1,
            duration: 0.6,
            delay: 0.2,
            onComplete: () => {
                mySplitText.revert();
            },
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        triggerTimer() {
            this.timerTl = gsap.timeline({ repeat: -1, repeatDelay: 0 });
            this.timerTl.set('.home-slider__timer-bar__indicator', { x: '-100%' }, 0);
            this.timerTl.to('.home-slider__timer-bar__indicator', {
                x: 0,
                duration: 4.6,
                ease: 'none',
                onComplete: this.handleNext,
            }, 0);
            this.timerTl.to('.home-slider__timer-bar__indicator', {
                x: '100%',
                duration: 0.4,
            }, '>');
            this.timerTl.play();
        },

        handlePrevious() {
            if (this.inProgress) {
                return;
            }
            this.inProgress = true;
            this.timerTl.restart();
            this.movement = 'left';
            if (this.currentIndex === 1) {
                this.currentIndex = this.maxIndex;
                return;
            }

            this.currentIndex -= 1;
        },

        handleNext() {
            if (this.inProgress) {
                return;
            }
            this.inProgress = true;
            this.timerTl.restart();
            this.movement = 'right';
            if (this.currentIndex === this.maxIndex) {
                this.currentIndex = 1;
                return;
            }

            this.currentIndex += 1;
        },

        beforeEnter(el) {
            const image = el.querySelector('.home-slider__slide-image');

            gsap.set(el, {
                zIndex: 3,
                opacity: 1,
            });

            gsap.set(image, {
                scale: 1.8,
                x: '-50%',
            });
        },

        enter(el, done) {
            const image = el.querySelector('.home-slider__slide-image');
            const title = el.querySelector('.home-slider__slide-text');

            const mySplitText = new SplitText(title, { type: 'lines', linesClass: 'line-reveal-line' });
            const dupSplitText = new SplitText(title, { type: 'lines', linesClass: 'line-reveal-line-holder' });
            const lines = el.querySelectorAll('.home-slider__slide-text .line-reveal-line');
            gsap.set(title, {
                opacity: 1,
            });
            const tl = gsap.timeline();
            tl.to(lines, {
                opacity: 1,
                y: 0,
                ease: 'Power2.out',
                stagger: 0.1,
                duration: 0.6,
                delay: 0.7,
                onComplete: () => {
                    mySplitText.revert();
                    done();
                },
            });
            gsap.to(image, {
                scale: 1.2,
                x: 0,
                duration: 0.8,
                ease: 'Power2.inOut',
                onComplete: () => {
                    this.inProgress = false;
                },
            });

            if (this.movement === 'left') {
                gsap.fromTo(el, {
                    scale: 1.2,
                }, {
                    scale: 1,
                    duration: 0.8,
                    ease: 'Power2.inOut',
                });
            } else {
                gsap.fromTo(el, { x: '100%' }, {
                    x: 0,
                    duration: 0.8,
                    ease: 'Power2.inOut',
                });
            }
        },

        afterEnter(el) {
            gsap.set(el, {
                x: 0,
                zIndex: 3,
            });
        },

        beforeLeave(el) {
            if (this.movement === 'left') {
                gsap.set(el, {
                    zIndex: 4,
                });
            } else {
                gsap.set(el, {
                    zIndex: 2,
                });
            }
        },

        leave(el, done) {
            const image = el.querySelector('.home-slider__slide-image');
            const title = el.querySelector('.home-slider__slide-text');

            gsap.to(title, {
                opacity: 0,
                duration: 0.4,
            });

            if (this.movement === 'left') {
                gsap.to(el, {
                    x: '100%',
                    duration: 0.8,
                    ease: 'Power2.inOut',
                });
                gsap.to(image, {
                    scale: 1.4,
                    x: '-50%',
                    duration: 0.8,
                    ease: 'Power2.inOut',
                    onComplete: () => {
                        gsap.set(el, {
                            x: 0,
                            zIndex: 2,
                            opacity: 0,
                        });
                        gsap.set(image, {
                            x: 0,
                        });
                    },
                });
            } else {
                gsap.to(image, {
                    scale: 1,
                    duration: 0.8,
                    ease: 'Power2.inOut',
                    onComplete: () => {
                        gsap.set(el, {
                            x: 0,
                            opacity: 0,
                        });
                        gsap.delayedCall(0.4, done);
                    },
                });
            }
        },

        afterLeave(el) {
            const image = el.querySelector('.home-slider__slide-image');

            gsap.set(image, {
                scale: 1.8,
            });
            gsap.set(el, {
                x: 0,
                zIndex: 2,
                opacity: 0,
            });
        },
    },
});
